<template>
  <DBox
    :id="'cmp-catalog-tracks-sidewindow-track_external_ids'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('external_ids')"
    @add_click="onAddExternalIDs"
  >
    <NTable
      id="catalog-tracks-sidewindow-track_external_ids-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('text01')">
            <TextField2
              :id="'text01'"
              :showLabel="false"
              :value="item['text01']"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('text02')">
            <TextField2
              :id="'text02'"
              :showLabel="false"
              :value="item['text02']"
              @blur="e => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteIDs(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { TracksService } from "../../services/tracks.service";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedTrackDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.selectedTrackDetails?.external_ids || [];
    },
    headers: function() {
      return [
        createTableHeader("text01", { text: "Account" }),
        createTableHeader("text02", { text: "External ID" }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    track_id: function() {
      return this.$route.params.track_id;
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      console.log("payload ", { name, value, item });
      this.$emit("changed", { name, value, item });
    },

    onAddExternalIDs: async function() {
      const res = await TracksService.addExternalIds(this.track_id);
      this.$emit("added", res.data);
    },

    onDeleteIDs: async function(item) {
      const confirmationResult = await confirmDelete(
        "External Id",
        item.relation_id + " " + item.text01
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    }
  }
};
</script>
